export const subtitles = {
    "1": {
        "startTime": 0.0,
        "endTime": 1.92,
        "transcript": "...ayagalallrat",
        "translation": "...in their travels"
    },
    "2": {
        "startTime": 4.3,
        "endTime": 7.79,
        "transcript": "Kit'ellrianek niiqurangukut maa-i.",
        "translation": "We always hear about people drowning now."
    },
    "3": {
        "startTime": 7.792,
        "endTime": 12.972,
        "transcript": "Cam, qaillun taukuk wani qalarutekniagken.",
        "translation": "Please talk about what and how."
    },
    "4": {
        "startTime": 14.257,
        "endTime": 24.047,
        "transcript": "(Yaa.) Ayuqeltassiigullukek (Ii-i.) cukanrarluni cukaunani kit'ellrak, kit'elallrak naliak amllenrua ciin-llu?",
        "translation": "(Okay.) Compare (Yes.) drowning when going fast and going slow, which one has more drownings and why?"
    },
    "5": {
        "startTime": 26.677,
        "endTime": 31.607,
        "transcript": "Kitak' tamana wani qanrutkeqerru.",
        "translation": "Please speak about that."
    },
    "6": {
        "startTime": 33.937,
        "endTime": 46.657,
        "transcript": "Tamaa-i, tamaa-i tamatum nalliini ayagassuutengqertut qayanek.",
        "translation": "Back at that time, they had kayaks for traveling."
    },
    "7": {
        "startTime": 47.047,
        "endTime": 59.922,
        "transcript": "Tua-llu anuqengararutaqateng qaspengqerrluteng-llu imkunek maklaaret qiluitnek.",
        "translation": "Then when the wind suddenly picked up on them, they had thin pullovers made of bearded seal intestines."
    },
    "8": {
        "startTime": 59.922,
        "endTime": 65.252,
        "transcript": "Irnerrlugnek qaspernek all'uki pitulinek.",
        "translation": "Seal gut pullovers that they put on."
    },
    "9": {
        "startTime": 65.382,
        "endTime": 71.802,
        "transcript": "Tamakunek qayam una painga, iciw' uivenqellriit?",
        "translation": "With those, the rim of the kayak here, you know how they're round?"
    },
    "10": {
        "startTime": 72.127,
        "endTime": 74.837,
        "transcript": "Qayanek-qaa tanglallruuten? (Yaa.)",
        "translation": "Would you see kayaks? (Yes.)"
    },
    "11": {
        "startTime": 74.837,
        "endTime": 77.052,
        "transcript": "Iciw' uivenqellriit?",
        "translation": "You know how they're round?"
    },
    "12": {
        "startTime": 77.052,
        "endTime": 82.472,
        "transcript": "Kinguqaminek qumigluku qayam painga.",
        "translation": "[S]he would put the hem around the rim of the kayak."
    },
    "13": {
        "startTime": 82.477,
        "endTime": 92.977,
        "transcript": "Tua-i-llu nutaan pelacinaunrilngurmek tapengyaarmek pinevkarluku piliameggnek nemerluku. Tua-i-gguq ket'garluku.",
        "translation": "Then finally, bind it, not with twine, but with binding material that they made by cutting sealskin in a spiral. They call that ket'garluku."
    },
    "14": {
        "startTime": 93.022,
        "endTime": 101.002,
        "transcript": "Tua-i qairem waten pilangraani iterciiganani qayaan iluanun.",
        "translation": "Though a wave does this to him, it can't go inside his kayak."
    },
    "15": {
        "startTime": 101.647,
        "endTime": 105.747,
        "transcript": "Tuaten pitulliniit, pitullruut.",
        "translation": "They used to do that."
    },
    "16": {
        "startTime": 105.982,
        "endTime": 111.742,
        "transcript": "Qayaan iluanun iterciiganani meq qumikngani.",
        "translation": "Water can't go inside his kayak because it's under his hem."
    },
    "17": {
        "startTime": 112.227,
        "endTime": 121.277,
        "transcript": "Tua-ll' makut wani angyat kill'uteng-llu piksaitelaryaaqut.",
        "translation": "Then these boats, they've don't really sink."
    },
    "18": {
        "startTime": 121.357,
        "endTime": 132.972,
        "transcript": "Tau͡gaam mat'um, mat'um aturyulallrata atungnaq'lallrata picurlagavkalarai.",
        "translation": "But this thing they tend to abuse, try to abuse, leads them to misfortune."
    },
    "19": {
        "startTime": 132.972,
        "endTime": 139.162,
        "transcript": "Picurlagatek'larai taangamek aterpagcimalria.",
        "translation": "What's called alcohol leads them to misfortune."
    },
    "20": {
        "startTime": 139.702,
        "endTime": 144.322,
        "transcript": "Tamakutaitellrani picurlalriartaitellruuq.",
        "translation": "When there was none of that, there were no accidents."
    },
    "21": {
        "startTime": 144.517,
        "endTime": 152.207,
        "transcript": "Picurlalriamek niicuitellruukut kiagmi kit'ellriamek.",
        "translation": "We didn't hear of anyone in an accident, drowning, in the summer."
    },
    "22": {
        "startTime": 152.347,
        "endTime": 163.977,
        "transcript": "Maa-i mat'um, mat'um tua-i atuusqumanricaaqaat nunat tamarmeng yuita ayagyuat.",
        "translation": "Now, people in every village don't want the youth to abuse it."
    },
    "23": {
        "startTime": 164.427,
        "endTime": 167.957,
        "transcript": "Ayagyuanrilnge'rmeng-llu pilalriit.",
        "translation": "They do it even if they're not young."
    },
    "24": {
        "startTime": 168.077,
        "endTime": 174.117,
        "transcript": "Kanevtellriatun waten, kanevtellriatun ayuqluku.",
        "translation": "Dying in great numbers like this, like they're being scattered."
    },
    "25": {
        "startTime": 174.362,
        "endTime": 179.762,
        "transcript": "Tua-i tuaten wii ayuqekutela'arqa, kanevtellriatun.",
        "translation": "That's how I compare it, like being scattered."
    },
    "26": {
        "startTime": 179.847,
        "endTime": 189.917,
        "transcript": "Iciw' kanevciaqamta tua-i kanvelalria. Imna-ll' taryirissuutmek pilallerput kanvaqluni.",
        "translation": "You know when we scatter things, they scatter. And what we call a salt shaker scatters [salt]."
    },
    "27": {
        "startTime": 190.247,
        "endTime": 203.727,
        "transcript": "Tuarpiaq umyuartequra'rqama tuaten tua-i kanvutekluku man'a aturyulallrat.",
        "translation": "It truly seems, when I ponder upon it, that what they tend to abuse makes them die in great numbers like that."
    },
    "28": {
        "startTime": 204.14,
        "endTime": 209.56,
        "transcript": "Tamakut camek nallullruut tamatutaitellrani.",
        "translation": "They didn't know of any [accidents] when there was none of that [alcohol]."
    },
    "29": {
        "startTime": 209.64,
        "endTime": 215.45,
        "transcript": "Tamakutaitellrani picurlagayuunateng.",
        "translation": "When there was none of that, they wouldn't get into many accidents."
    },
    "30": {
        "startTime": 215.45,
        "endTime": 225.46,
        "transcript": "Tuaten tua-i. Angenricaaqut-ll' au͡gkut ayagassuutek'lallriit. Qayat kiingita ayagassuutait.",
        "translation": "Like that. Their means of travel back then also weren't big. Kayaks were their only means of travel."
    },
    "31": {
        "startTime": 227.29,
        "endTime": 237.75,
        "transcript": "Man'a kitak' cali waten maa-i niiqurangelriakut qanruyutet niitnaunrirniluki.",
        "translation": "So now, we also hear now that we don't hear traditional wisdom anymore."
    },
    "32": {
        "startTime": 237.75,
        "endTime": 244.7,
        "transcript": "Elpeni cali murilkellerpeni ciin qanruyutet qanruteknanrirpakartatki?",
        "translation": "In your observation, why don't they talk about traditional wisdom anymore?"
    },
    "33": {
        "startTime": 244.7,
        "endTime": 257.35,
        "transcript": "Tua-i, tua-i au͡gkut, au͡gkut ciuqlimta, ciuqliput nang'ngata.",
        "translation": "It's because our elders are all gone."
    },
    "34": {
        "startTime": 258.01,
        "endTime": 271.04,
        "transcript": "Qanruyutet tamakunek ciuqlimteńek qanrutkestairucata. Qanrutkestairutut.",
        "translation": "It's because there's none of our elders to speak of that traditional wisdom. There's no one to talk about them anymore."
    },
    "35": {
        "startTime": 272.91,
        "endTime": 278.88,
        "transcript": "Ilaita-llu nallunrit'laryaaqellikait tayima.",
        "translation": "And some probably know them."
    },
    "36": {
        "startTime": 279.7,
        "endTime": 286.13,
        "transcript": "Qanruyun ak'allaq niitelaryaaqellikii.",
        "translation": "[Some] probably hear about the old traditional wisdom."
    },
    "37": {
        "startTime": 286.63,
        "endTime": 292.9,
        "transcript": "Tamaa-i qanrutkurtairucami.",
        "translation": "It's because there's no one to speak about them anymore."
    },
    "38": {
        "startTime": 293.31,
        "endTime": 306.87,
        "transcript": "Atam tamakut tamaa-i angullrenka qalaruyutseng cimiqetaarpek'naku.",
        "translation": "You see, the people I was born in time to see wouldn't change what they were instructed."
    },
    "39": {
        "startTime": 306.87,
        "endTime": 312.5,
        "transcript": "Atauciq tua-i atauciuluku qalarutkuratuat.",
        "translation": "They'd speak of one thing in one way."
    },
    "40": {
        "startTime": 312.71,
        "endTime": 317.39,
        "transcript": "Uum qalartaqami qanrutkaqluku.",
        "translation": "When one instructed, [s]he'd speak of it."
    },
    "41": {
        "startTime": 317.39,
        "endTime": 323.35,
        "transcript": "Akaurpailgan allam uum qanraqami qanrutkaqluku.",
        "translation": "Before long, when another instructed, [s]he'd speak of it."
    },
    "42": {
        "startTime": 323.51,
        "endTime": 333.59,
        "transcript": "Tamaa-i tamakunek tegganrurtellrianek qalarutkestairucameng",
        "translation": "Because there are none of those who've become elders to talk about them anymore"
    },
    "43": {
        "startTime": 333.86,
        "endTime": 345.0,
        "transcript": "Qanruyun man'a qanrutkuranriraat nang'ngameng tamakut qalarutkestek'lallri.",
        "translation": "They don't talk about this traditional wisdom anymore, because those that talk about them are gone."
    },
    "44": {
        "startTime": 345.68,
        "endTime": 353.66,
        "transcript": "Waten, waten cali makut wani ciuliaput waten qanerturalalriit",
        "translation": "Also, our elders here say this"
    },
    "45": {
        "startTime": 353.66,
        "endTime": 365.99,
        "transcript": "Qanerturalalriit-wa tuar, tuar qanruyutet pinrillrat ayagyuanun elliluku qanrucunairutniluta.",
        "translation": "They always say, it seems, it seems that they put [the blame] on young people for the disconinuation of traditional wisdom, saying that we don't heed advice anymore."
    },
    "46": {
        "startTime": 366.22,
        "endTime": 372.4,
        "transcript": "Ciin, ciin tamana cali tuaten piularta maa-i?",
        "translation": "Why is it like that now?"
    },
    "47": {
        "startTime": 372.4,
        "endTime": 380.34,
        "transcript": "Tua-i maa-i tang atungekvut tua-i tamana imna qanrutkelallrat.",
        "translation": "Now, you see, we've started experiencing what they'd talk about."
    },
    "48": {
        "startTime": 380.96,
        "endTime": 384.86,
        "transcript": "Qanrutkelallrat atungekvut.",
        "translation": "We're starting to experience what they'd talk about."
    },
    "49": {
        "startTime": 386.317,
        "endTime": 393.187,
        "transcript": "Qanqauteng'e'rmi aturciigaliluku ilii.",
        "translation": "Though one is given advice, [s]he cannot follow it."
    },
    "50": {
        "startTime": 393.487,
        "endTime": 399.827,
        "transcript": "Niicugnirraarluni tua-i-ll' ayagluni tua-i unilluku.",
        "translation": "After listening, then [s]he goes away, leaving [the instructor]."
    },
    "51": {
        "startTime": 402.362,
        "endTime": 411.592,
        "transcript": "Tamaa-i tamana ciuqvaar umyuaqluku ilaita pilallruut.",
        "translation": "With that, some would think of the far future."
    },
    "52": {
        "startTime": 411.592,
        "endTime": 414.672,
        "transcript": "Maa-i tua-i qanrutkelallrat.",
        "translation": "This is what they spoke of."
    },
    "53": {
        "startTime": 415.067,
        "endTime": 421.557,
        "transcript": "Qanruyun atunrirciqniluku-ll' wii niigartelallruunga.",
        "translation": "I'd also hear that they won't adhere to traditional wisdom anymore."
    },
    "54": {
        "startTime": 421.697,
        "endTime": 427.907,
        "transcript": "Qanrutestairuskata qanruyun atunrirciqniluku.",
        "translation": "They said that when they have no more instructors, they won't adhere to traditional wisdom anymore."
    },
    "55": {
        "startTime": 427.967,
        "endTime": 432.007,
        "transcript": "Avani ciuqvaarni niigartelallruaqa.",
        "translation": "I'd hear that a long time ago back then."
    },
    "56": {
        "startTime": 435.572,
        "endTime": 443.142,
        "transcript": "Maa-i-qaa tamana niitelallren elpeni piciurtenguq qanruyun atunrir[ciqniluku]?",
        "translation": "Now, to you, is it true what they said about how they'd stop adhering to traditional wisdom?"
    },
    "57": {
        "startTime": 443.142,
        "endTime": 448.122,
        "transcript": "Ii-i, ii-i, piciurtuq tua-i maa-i.",
        "translation": "Yes, yes, it's come true now."
    },
    "58": {
        "startTime": 448.707,
        "endTime": 462.067,
        "transcript": "Tang au͡gkut yaaqvaq-llu tekitarkaq nallunrilngurtun pilallrulliniut, nallunrilngurtun.",
        "translation": "You see, it was like people back then knew what was a long time to come, like they knew."
    },
    "59": {
        "startTime": 468.742,
        "endTime": 474.812,
        "transcript": "Camek wani elpet tua-i paiciryullerpenek",
        "translation": "Whatever [wisdom] that you want to leave with us"
    },
    "60": {
        "startTime": 475.302,
        "endTime": 484.712,
        "transcript": "Wangkuta ayagyuani wall'u niicugnilriani camek alerquutmek paicirluta.",
        "translation": "Leave us young people, or those listening, with some traditional instruction."
    },
    "61": {
        "startTime": 484.712,
        "endTime": 485.732,
        "transcript": "Ii-i.",
        "translation": "Okay."
    },
    "62": {
        "startTime": 485.737,
        "endTime": 488.057,
        "transcript": "Camek elpet paiciryarcikut?",
        "translation": "What would you leave with us?"
    },
    "63": {
        "startTime": 488.462,
        "endTime": 494.952,
        "transcript": "Paiciutekaqa, paiciuteksugyaaqek'ngaqa waniwa:",
        "translation": "I leave behind, this is what I want to leave behind:"
    },
    "64": {
        "startTime": 495.262,
        "endTime": 500.172,
        "transcript": "Kenkulluci, ayagyualriani kenkulluku.",
        "translation": "Treat each other with love, young people, treat each other with love."
    },
    "65": {
        "startTime": 500.172,
        "endTime": 505.082,
        "transcript": "Ilaci cangayugcetaarpek'naki pisqelluci.",
        "translation": "I tell you not to affront those around you."
    },
    "66": {
        "startTime": 505.082,
        "endTime": 510.752,
        "transcript": "Ilakelriatun ayuqulluci elpeceńek.",
        "translation": "Treat each other as family."
    },
    "67": {
        "startTime": 510.752,
        "endTime": 519.702,
        "transcript": "Maa-i tang makut wani iqlutmun ayagarcukaarangelria",
        "translation": "Now, you see, these people easily go astray."
    },
    "68": {
        "startTime": 520.902,
        "endTime": 525.822,
        "transcript": "Qanruyutni, wall'u cangayullni ayagneqluku.",
        "translation": "Starting from traditional wisdom, or, being offended."
    },
    "69": {
        "startTime": 525.867,
        "endTime": 533.477,
        "transcript": "Ayuqlutek, ayuqlutek arnaunge'rmi tuaten ayuqliriuq.",
        "translation": "[Man and woman] the same, the same, even a woman has become like that."
    },
    "70": {
        "startTime": 533.767,
        "endTime": 545.577,
        "transcript": "Cangayuutni iqlutmun ayagarutekarkauluku. Iqlutmuqrulluku, iqlutmuqrutekluku.",
        "translation": "She goes astray because of being offended. She goes astray from that."
    },
    "71": {
        "startTime": 546.737,
        "endTime": 555.987,
        "transcript": "Tau͡gaam waten, waten atam cangayugcetaarpek'nani ilaci ayagyuallguceci.",
        "translation": "But like this, do not affront your fellow young people."
    },
    "72": {
        "startTime": 555.987,
        "endTime": 562.402,
        "transcript": "Angutngurtengraan wall' arnaurtengraan ayuqluku piurquvci",
        "translation": "If you treat them the same, even if they've become a man or woman"
    },
    "73": {
        "startTime": 562.402,
        "endTime": 570.032,
        "transcript": "Imutun tua-i uqisngauralriatun, uqisngauralriatun ayuqniartuci.",
        "translation": "So it will be like you're sheltered, like you're sheltered."
    },
    "74": {
        "startTime": 570.102,
        "endTime": 578.622,
        "transcript": "Man'a maa-i umyuaqelarniaran catairut'nge'rma-llu wii.",
        "translation": "Remember this even when I'm gone."
    },
    "75": {
        "startTime": 579.187,
        "endTime": 584.247,
        "transcript": "Ii-i, quyana. Quyana qalangssaulluta.",
        "translation": "Okay, thank you. Thank you for speaking with us."
    }
};